module.exports = __webpack_public_path__ + "static/img/222_TO8_1946_og.456fd46.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/222_TO8_1946_og.jpg
// module id = kkLt
// module chunks = 0